module.exports = __webpack_public_path__ + "img/table-spread.3027d80c.png";